import { IMAStrategy } from "../types/MAStrategy";

export const initialMaStrategyOverview: IMAStrategy = {
    intentions: "",
    acquisition: 0,
    challenge: 0,
    acquisitionBudget: "",
    mainAcquisition: 0
};